import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import {
  CEEAVehicleTabs,
  SharedVehicleTabs,
  FEATURE,
  SHOW_FAVOURITE_VEHICLES,
  SHOW_VEHICLE_COMMENTS,
  SHOW_VEHICLE_SNAPSHOTS,
  BATCH_IMPORT,
  DASH_LAYOUT,
  FEATURE_COLLECTION_DETAILS,
} from 'utils/constants'

// TODO: move to navigator folder (like power take off)
import FeatureNavigator from 'components/feature/Navigator/FeatureNavigator'
import PtoNavigator from 'components/vehicles/PowerTakeOff/PtoNavigator'
import EcusNavigator from 'components/vehicles/Ecus/EcusNavigator'
import SwitchAndGaugeNavigator from 'components/vehicles/SwitchAndGauge/SwitchAndGaugeNavigator'
import VehicleNavigator from 'components/vehicles/VehicleNavigator'
import { useSelector } from 'react-redux'
import { getSelectedId } from 'selectors/navigator'
import VehicleSnapshotsFlyout from 'components/VehicleSnapshotsFlyout'
import FavoriteVehiclesDrawer from 'components/vehicles/FavoriteVehiclesDrawer'
import CommentsDrawer from 'components/vehicles/CommentsDrawer/CommentsDrawer'
import BatchImport from 'components/feature/BatchImport/BatchImportMain'
import FeatureCollectionDetailsDrawer from 'components/pages/FeatureCollectionDetails/FeatureCollectionDetailsDrawer'

const pathsWithNav = {
  feature: FEATURE,
  pneumatics: CEEAVehicleTabs.pneumatics,
  switchandgauge: SharedVehicleTabs.switchandgauge,
  powerTakeOff: CEEAVehicleTabs.powerTakeOff,
  vehicle: SharedVehicleTabs.vehicle,
  ecus: SharedVehicleTabs.ecus,
}
const allPathsWithNav = new RegExp(Object.values(pathsWithNav).join('|'))

const Render = ({ location }) => {
  const selectedId = useSelector(getSelectedId)

  if (selectedId === SHOW_FAVOURITE_VEHICLES) {
    return <FavoriteVehiclesDrawer />
  }
  if (selectedId === SHOW_VEHICLE_SNAPSHOTS) {
    return <VehicleSnapshotsFlyout />
  }
  if (selectedId === SHOW_VEHICLE_COMMENTS) {
    return <CommentsDrawer />
  }

  if (selectedId === FEATURE_COLLECTION_DETAILS) {
    return <FeatureCollectionDetailsDrawer />
  }

  const path = location.pathname
  // guard clause
  // ensure path is not /vehicles$ index page
  if (
    (!allPathsWithNav.test(path) || /\/vehicles$/.test(path)) &&
    !path.includes(DASH_LAYOUT)
  )
    return null

  const { feature, powerTakeOff, switchandgauge, vehicle, ecus } = pathsWithNav

  if (path.includes(feature) && selectedId === BATCH_IMPORT) {
    return <BatchImport />
  }

  if (path.includes(feature)) {
    return <FeatureNavigator />
  }

  if (path.includes(powerTakeOff)) {
    return <PtoNavigator selectedId={selectedId} />
  }

  if (path.includes(switchandgauge) || path.includes(DASH_LAYOUT)) {
    return <SwitchAndGaugeNavigator />
  }

  if (path.includes(ecus)) {
    return <EcusNavigator location={location} />
  }

  if (path.includes(vehicle)) {
    return <VehicleNavigator />
  }

  return null
}

Render.propTypes = {
  location: PropTypes.object.isRequired,
}

export default React.memo(withRouter(Render))
